<div
  class="pp-modal__backdrop"
  [class.pp-modal__backdrop--visible]="isOpen()"
  aria-hidden="true"
  (click)="onBackdropClick($event)"
></div>

<section
  #modalEl
  class="pp-modal"
  [class.pp-modal--open]="isOpen()"
  role="dialog"
  aria-modal="true"
  aria-labelledby="pp-modal-title"
  tabindex="-1"
>
  <header class="pp-modal__header">
    <div class="pp-modal__header-info">
      <app-icon [icon]="giftIcon" [size]="20" color="var(--color-brand-secondary)" />
      <h2 id="pp-modal-title" class="pp-modal__title">{{ copy.title }}</h2>
    </div>
    <button
      #closeBtn
      class="pp-modal__close"
      type="button"
      [attr.aria-label]="copy.closeAriaLabel"
      (click)="onClose()"
    >
      <app-icon [icon]="closeIcon" [size]="20" color="currentColor" />
    </button>
  </header>

  <div class="pp-modal__body">
    @if (status() === 'success') {
      <p class="pp-modal__success" aria-live="polite">
        <app-pp-coin face="corgi" [size]="18" />{{ copy.successPrefix }} {{ successMessage() }}
      </p>
    } @else {
      <form class="pp-modal__form" (submit)="onSubmit($event)">
        <label class="pp-modal__label" for="pp-code">
          {{ copy.inputLabel }}
        </label>
        <p class="pp-modal__intro">{{ copy.intro }}</p>
        <div #inputWrap class="pp-modal__input-wrap">
          <app-input
            id="pp-code"
            type="text"
            [placeholder]="copy.inputPlaceholder"
            [value]="code()"
            [disabled]="status() === 'pending'"
            (valueChange)="code.set($event)"
          />
        </div>
        @if (status() === 'invalid') {
          <p class="pp-modal__error" aria-live="polite">{{ copy.invalid }}</p>
        } @else if (status() === 'consumed') {
          <p class="pp-modal__error" aria-live="polite">{{ copy.consumed }}</p>
        } @else if (status() === 'throttled') {
          <p class="pp-modal__error" aria-live="polite">{{ copy.throttled }}</p>
        } @else if (status() === 'error') {
          <p class="pp-modal__error" aria-live="polite">{{ copy.error }}</p>
        }
        <div class="pp-modal__actions">
          <app-button variant="ghost" size="md" type="button" (click)="onClose()">
            {{ copy.cancel }}
          </app-button>
          <app-button
            variant="primary"
            size="md"
            type="submit"
            [disabled]="!canSubmit()"
            [loading]="status() === 'pending'"
          >
            {{ copy.cta }}
          </app-button>
        </div>
      </form>
    }
  </div>
</section>
